class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Bouton Vider le panier
document.addEventListener('click', function(e) {
  const clearCartButton = e.target.closest('.clear-cart-btn');

  if (!clearCartButton) return;

  const existingDialog = document.querySelector('.clear-cart-dialog');
  if (existingDialog) existingDialog.remove();

  const dialog = document.createElement('div');
  dialog.className = 'clear-cart-dialog';
  dialog.innerHTML = `
    <div class="clear-cart-dialog__overlay"></div>
    <div
      class="clear-cart-dialog__content"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="ClearCartDialogTitle"
      aria-describedby="ClearCartDialogDescription"
    >
      <h2 id="ClearCartDialogTitle" class="clear-cart-dialog__title">Supprimer le panier ?</h2>
      <p id="ClearCartDialogDescription" class="clear-cart-dialog__description">
        Tous les articles de votre panier vont être supprimés. Cette action est définitive.
      </p>
      <p class="clear-cart-dialog__error" role="alert" hidden>
        Une erreur est survenue. Votre panier n’a pas été supprimé.
      </p>
      <div class="clear-cart-dialog__actions">
        <button type="button" class="clear-cart-dialog__cancel">Annuler</button>
        <button type="button" class="clear-cart-dialog__confirm">Supprimer</button>
      </div>
    </div>
  `;

  document.body.appendChild(dialog);
  document.body.classList.add('overflow-hidden');

  const cancelButton = dialog.querySelector('.clear-cart-dialog__cancel');
  const confirmButton = dialog.querySelector('.clear-cart-dialog__confirm');
  const errorMessage = dialog.querySelector('.clear-cart-dialog__error');

  const closeDialog = () => {
    dialog.remove();
    if (!document.querySelector('cart-drawer.active')) {
      document.body.classList.remove('overflow-hidden');
    }
    clearCartButton.focus();
  };

  cancelButton.addEventListener('click', closeDialog);
  dialog.querySelector('.clear-cart-dialog__overlay').addEventListener('click', closeDialog);

  dialog.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') closeDialog();

    if (event.key === 'Tab') {
      if (event.shiftKey && document.activeElement === cancelButton) {
        event.preventDefault();
        confirmButton.focus();
      } else if (!event.shiftKey && document.activeElement === confirmButton) {
        event.preventDefault();
        cancelButton.focus();
      }
    }
  });

  confirmButton.addEventListener('click', function() {
    confirmButton.disabled = true;
    cancelButton.disabled = true;
    confirmButton.setAttribute('aria-busy', 'true');
    errorMessage.hidden = true;

    fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart clear failed');
        window.location.reload();
      })
      .catch(() => {
        confirmButton.disabled = false;
        cancelButton.disabled = false;
        confirmButton.removeAttribute('aria-busy');
        errorMessage.hidden = false;
        confirmButton.focus();
      });
  });

  cancelButton.focus();
});
